import type { ComponentType } from 'react';
import type { TimelineLayerId } from 'features/mapping/mapping.constants';
import {
  RADAR_LEGEND_TEXT_LABELS,
  RadarLegend,
} from 'features/mapping/components/layers/RadarLayer';
import { ConnectedLightningTimelineLegend } from 'features/mapping/components/layers/LightningLayer';

type TimelineLegendProps = {
  isLoading: boolean;
};

type TimelineLayerLegend = {
  Legend: ComponentType<TimelineLegendProps>;
  /** Sizes the mobile legend strip */
  itemCount: number;
};

export const TIMELINE_LAYER_LEGENDS: Partial<
  Record<TimelineLayerId, TimelineLayerLegend>
> = {
  radar: { Legend: RadarLegend, itemCount: RADAR_LEGEND_TEXT_LABELS.length },
  lightning: { Legend: ConnectedLightningTimelineLegend, itemCount: 3 },
};
